export default {
  methods: {
    defineTransSize(model) {
      let size = null;
      if (model === "AE") {
        size = this.transitionsFlowModelAE.length;
      }
      if (model === "AP") {
        size = this.transitionsFlowModelAP.length;
      }
      if (model === "AMP") {
        size = this.transitionsFlowModelAMP.length;
      }
      if (model === "AR") {
        size = this.transitionsFlowModelAR.length;
      }
      if (model === "B") {
        size = this.transitionsFlowModelB.length;
      }
      if (model === "BO") {
        size = this.transitionsFlowModelBO.length;
      }
      if (model === "CB") {
        size = this.transitionsFlowModelCB.length;
      }
      if (model === "CP") {
        size = this.transitionsFlowModelCP.length;
      }
      if (model === "CS") {
        size = this.transitionsFlowModelCS.length;
      }
      if (model === "D") {
        size = this.transitionsFlowModelD.length;
      }
      if (model === "E") {
        size = this.transitionsFlowModelE.length;
      }
      if (model === "Y") {
        size = this.transitionsFlowModelY.length;
      }
      return size;
    },
    defineTransInfo(level, model) {
      let obj = null;
      let list = null;
      if (model === "AE") {
        list = this.transitionsFlowModelAE;
      }
      if (model === "AP") {
        list = this.transitionsFlowModelAP;
      }
      if (model === "AMP") {
        list = this.transitionsFlowModelAMP;
      }
      if (model === "AR") {
        list = this.transitionsFlowModelAR;
      }
      if (model === "B") {
        list = this.transitionsFlowModelB;
      }
      if (model === "BO") {
        list = this.transitionsFlowModelBO;
      }
      if (model === "CB") {
        list = this.transitionsFlowModelCB;
      }
      if (model === "CP") {
        list = this.transitionsFlowModelCP;
      }
      if (model === "CS") {
        list = this.transitionsFlowModelCS;
      }
      if (model === "D") {
        list = this.transitionsFlowModelD;
      }
      if (model === "E") {
        list = this.transitionsFlowModelE;
      }
      if (model === "Y") {
        list = this.transitionsFlowModelY;
      }
      obj = list[level];
      return obj;
    }
  },
  data() {
    return {
      transitionsStatusTypes: [
        {
          type: "revert",
          icon: "sync_problem",
          title: "Approval reverted, review new request",
          col: "wplorange0", // color
          com: "" // comment left by user
        }
      ],
      transitionsFlowModelA: [
        {
          type: "A", // type of decision
          title: "Created", // type of step
          icon: "add", // icon for decision
          lvl: 1, // stage / level of approval
          // eslint-disable-next-line
          comn: "Submit for review.", // comment next (next step)
          comc: "Operation is completed.", // comment current (comc)
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "A",
          title: "Submitted",
          icon: "sync_alt",
          lvl: 2,
          // eslint-disable-next-line
          comn: "Verify the proposed change is as per Strategy.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "A",
          title: "Validated",
          icon: "info",
          lvl: 3,
          comn: "Add technical and business info.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "A",
          title: "Review",
          icon: "troubleshoot",
          lvl: 4,
          comn: "Complete review process.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "A",
          title: "Approved",
          icon: "policy",
          lvl: 5,
          comn: "Review and publish.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "A",
          title: "Published",
          icon: "verified",
          lvl: 6,
          comn: "Ready for Use!",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "A",
          title: "Published",
          icon: "lock",
          lvl: 7,
          comn: "do this next",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        }
      ],
      transitionsFlowModelAE: [
        {
          type: "AE", // type of decision
          title: "Created", // type of step
          icon: "add", // icon for decision
          lvl: 1, // stage / level of approval
          // eslint-disable-next-line
          comn: "Describe problem in the context of engineering services requirements. Justify why engineering services are required.", // comment next (next step)
          comc: "Operation is completed.", // comment current (comc)
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AE",
          title: "Review",
          icon: "sync_alt",
          lvl: 2,
          // eslint-disable-next-line
          comn: "Review engineering requirements, confirm problem is understood and clearly state the terms of reference for engineering scope. Agreeing to commit means assigning engineering resources.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AE",
          title: "Accept",
          icon: "check_circle_outline",
          lvl: 3,
          // eslint-disable-next-line
          comn: "Accept the scope of work defined by the review team. Analyse the problem with data and evidence, then develop solutions and recommend technical option to the business.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AE",
          title: "Check",
          icon: "check",
          lvl: 4,
          // eslint-disable-next-line
          comn: "Check engineering solution in the context of technical feasibility, technology maturity and ability to adopt the solution into site system and business processes.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AE",
          title: "Busienss",
          icon: "price_check",
          lvl: 5,
          // eslint-disable-next-line
          comn: "Complete detailed economic evaluation and screening. Validate that proposed technical solution has a commercial merit.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AE",
          title: "Recommend",
          icon: "manage_accounts",
          lvl: 6,
          // eslint-disable-next-line
          comn: "Review the recommended solution, reviewing cost and carbon impact. Review solution in the context of the defined engineering scope. Assign execution plan dates and budget.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AE",
          title: "Decide",
          icon: "shield",
          lvl: 7,
          // eslint-disable-next-line
          comn: "Review if the technically verified and commercially screened recommended solution meets all business objectives and strategies.  Decider is agreeing to commit the resources to the recommended modification or to agree to current risk.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AE",
          title: "Approved",
          icon: "verified",
          lvl: 8,
          // eslint-disable-next-line
          comn: "Prepare for implementation for permanent and temporary changes both hardware or software. In some engineering decisions, there is no preparation or resourcing but only decision about risk identification.",
          // eslint-disable-next-line
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AE",
          title: "Completed",
          icon: "check_box",
          lvl: 9,
          // eslint-disable-next-line
          comn: "Work completed in the field or communication and acknowledgment was completed. Monitor for any post commissioning faults and listen to site feedback for any warranty requests. Commence update all project and site documents.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AE",
          title: "Closed",
          icon: "copyright",
          lvl: 10,
          // eslint-disable-next-line
          comn: "New system is commissioned and under care and custody of site teams. All project and site documents have been updated.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        }
      ],
      transitionsFlowModelAP: [
        {
          type: "AE", // type of decision
          title: "Created", // type of step
          icon: "add", // icon for decision
          lvl: 1, // stage / level of approval
          // eslint-disable-next-line
          comn: "Confirm new procedure request is valid.", // comment next (next step)
          comc: "Operation is completed.", // comment current (comc)
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AE",
          title: "Develop",
          icon: "settings_suggest",
          lvl: 2,
          // eslint-disable-next-line
          comn: "Develop technical tasks for the procedure and if required validate the procedure steps in the field either online / offline.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AE",
          title: "Review",
          icon: "manage_search",
          lvl: 3,
          // eslint-disable-next-line
          comn: "Review procedure details, required tools and parts to complete the tasks.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AE",
          title: "Recommend",
          icon: "manage_accounts",
          lvl: 4,
          // eslint-disable-next-line
          comn: "Review the recommended solution, reviewing cost and carbon imp, and most importantly if it addresses the study scope.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AE",
          title: "Decide",
          icon: "shield",
          lvl: 5,
          // eslint-disable-next-line
          comn: "Review submitted procedure and confirmed the procedure meets the technical objective intent and accept potential imp on business plans and budget.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AE",
          title: "Ready",
          icon: "verified",
          lvl: 6,
          // eslint-disable-next-line
          comn: "Procedure is ready to use, please review current version of the procedure and if it is adequate to be used across site or company. Always review the procedure prior to use as this is live document and is subject to authorised change.",
          // eslint-disable-next-line
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AE",
          title: "Cancelled",
          icon: "copyright",
          lvl: 7,
          // eslint-disable-next-line
          comn: "Procedure is cancelled or superseded by the custodian. The procedure is no longer valid and it must not be used in the field.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        }
      ],
      transitionsFlowModelAMP: [
        {
          type: "AMP", // type of decision
          title: "Created", // type of step
          icon: "add", // icon for decision
          lvl: 1, // stage / level of approval
          // eslint-disable-next-line
          comn: "Review maintenance plans for duplicates and alignment with maintenance and facility strategy.", // comment next (next step)
          comc: "Operation is completed.", // comment current (comc)
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AMP",
          title: "Develop",
          icon: "settings_suggest",
          lvl: 2,
          // eslint-disable-next-line
          comn: "Develop maintenance plan technical details, identify procedure, results criteria, assets, hazard and imp associated with the activity.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AMP",
          title: "Review",
          icon: "engineering",
          lvl: 3,
          // eslint-disable-next-line
          comn: "Review maintenance plan technical details. Confirm plan can be executed safely within specified maintenance window and can deliver a quality result.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AMP",
          title: "Plan",
          icon: "more_time",
          lvl: 4,
          // eslint-disable-next-line
          comn: "Develop detail resources plan for specified scope and assets. Confirm resources level is aligned with facility resource loading.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AMP",
          title: "Recommend",
          icon: "manage_accounts",
          lvl: 5,
          // eslint-disable-next-line
          comn: "Review the maintenance plan technically and commercially. Confirm resource plan is fit for purpose and economical. Reassess the maintenance strategy alignment with the developed maintenance plan. Consider existing maintenance plan batch numbers for improved execution efficiency.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AMP",
          title: "Decide",
          icon: "shield",
          lvl: 6,
          // eslint-disable-next-line
          comn: "The maintenance plan is reviewed and agreed by the business. Review maintenance strategy and proposed maintenance plan, accept budget, plan and facility imp to complete this plan.",
          // eslint-disable-next-line
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AMP",
          title: "Ready",
          icon: "verified",
          lvl: 7,
          // eslint-disable-next-line
          comn: "The maintenance plan is suspended and not longer permitted to be used. Contact plan custodian for additional information.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AMP",
          title: "Suspended",
          icon: "copyright",
          lvl: 7,
          // eslint-disable-next-line
          comn: "Procedure is cancelled or superseded by the custodian. The procedure is no longer valid and it must not be used in the field.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        }
      ],
      transitionsFlowModelAR: [
        {
          type: "AR", // type of decision
          title: "Created", // type of step
          icon: "add", // icon for decision
          lvl: 1, // stage / level of approval
          // eslint-disable-next-line
          comn: "Describe or review risk scenario, business impacts and propose to the business to recognised identified risk.", // comment next (next step)
          comc: "Operation is completed.", // comment current (comc)
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AR",
          title: "Review",
          icon: "sync_alt",
          lvl: 2,
          // eslint-disable-next-line
          comn: "Confirm the reviewed risk is understood and preliminary risk is communicated to relevant business stakeholders or operational facility staff.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AR",
          title: "Develop",
          icon: "settings_suggest",
          lvl: 3,
          // eslint-disable-next-line
          comn: "Accept the terms of reference defined by the review team. Analyse the risk, complete detailed risk assessment for different scenarios, check existing risk barriers and risk controls in the context of risk scenarios. Any identified severe risks must be communicated immediately to facility or corporate management.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AR",
          title: "Recommend",
          icon: "manage_accounts",
          lvl: 4,
          // eslint-disable-next-line
          comn: "Review the risk analysis against company tolerable risk levels and local laws. Confirm if additional risk mitigation or risk control is required. Confirm recommended risk management strategy.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AR",
          title: "Decide",
          icon: "shield",
          lvl: 5,
          // eslint-disable-next-line
          comn: "Review the risk rating and propose risk management. Consider impact on site and resources if the solution recommendation is implemented.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AR",
          title: "Prepare",
          icon: "event",
          lvl: 6,
          // eslint-disable-next-line
          comn: "Prepare for implementation of permanent and temporary changes to site or processes to complete risk management. A minimum requirement is communication of approved risk to impacted teams and sites.",
          // eslint-disable-next-line
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AR",
          title: "Completed",
          icon: "check_box",
          lvl: 7,
          // eslint-disable-next-line
          comn: "All agreed risk management framework tasks are completed, the risk was communicated and consulted with relevant impacted stakeholders. Evaluate risk controls effectiveness, validate next risk review date. Approve the Risk to Operational Phase.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AR",
          title: "Approved",
          icon: "verified",
          lvl: 8,
          // eslint-disable-next-line
          comn: "Risk management is approved and all risk tasks and controls have been implemented and validated. Monitor the situation for potential escalation, next risk review date, listen to feedback and reapprove risk management if required. Close risk if not longer relevant or credible to the business.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "AR",
          title: "Closed",
          icon: "copyright",
          lvl: 9,
          // eslint-disable-next-line
          comn: "The risk is closed and no longer credible or possible. Risk assessment audit or archive process are possible.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        }
      ],
      transitionsFlowModelB: [
        {
          type: "B", // type of decision
          title: "Created", // type of step
          icon: "add", // icon for decision
          lvl: 1, // stage / level of approval
          // eslint-disable-next-line
          comn: "Review work request and screen out low value work or an activity that is no longer required or is duplicate work.", // comment next (next step)
          comc: "Operation is completed.", // comment current (comc)
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "B",
          title: "Scope",
          icon: "manage_accounts",
          lvl: 2,
          // eslint-disable-next-line
          comn: "Review proposed scope of work and modify if required. Return to previous step if additional information about system condition is required to define the scope. Define all hazards and facility impacts with proposed scope execution.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "B",
          title: "Review",
          icon: "build_circle",
          lvl: 3,
          // eslint-disable-next-line
          comn: "Approve reviewed scope work and confirm that the proposed work is efficient and fit for purpose to address work requirements and business objectives.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "B",
          title: "Resource",
          icon: "category",
          lvl: 4,
          // eslint-disable-next-line
          comn: "Define parts / people /  procedures for defined scope. Any technical or planning queries are managed by Actions.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "B",
          title: "Plan",
          icon: "today",
          lvl: 5,
          // eslint-disable-next-line
          comn: "Confirm all resources are identified. Confirm that identified plan business limits are not exceeded and the work request is operating within the approved budget.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "B",
          title: "Decide",
          icon: "shield",
          lvl: 6,
          // eslint-disable-next-line
          comn: "Review recommended plan, budget and facility impacts for approved scope and resource plan. Approve or reject the work request proposal.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "B",
          title: "Preparation",
          icon: "next_week",
          lvl: 7,
          // eslint-disable-next-line
          comn: "Place order on identified materials and external vendor services, all special tools are validated, engineering queries are processed. Add Work Request to Plan. Schedule periodic review to confirm work preparation is progressing. Plan to prepare site for work execution.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "B",
          title: "Execute",
          icon: "verified",
          lvl: 8,
          // eslint-disable-next-line
          comn: "Confirm work is fullly resourced, the procedure is adequate, and  all permits are approved. Confirm site is safe and ready for work. Start work execution as per procedure and scope of work.",
          // eslint-disable-next-line
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "B",
          title: "Analysis",
          icon: "science",
          lvl: 9,
          // eslint-disable-next-line
          comn: "Confirm work is completed as per the scope. Verify technical results and authorise to start equipment or handover the system to operations.",
          // eslint-disable-next-line
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "B",
          title: "Ready",
          icon: "arrow_circle_right",
          lvl: 10,
          // eslint-disable-next-line
          comn: "Review technical results and approve to start the equipment in current condition or complete further work. Understand identified safety or reliability risks if applicable.",
          // eslint-disable-next-line
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "B",
          title: "Done",
          icon: "check_box",
          lvl: 11,
          // eslint-disable-next-line
          comn: "Work is technically completed and verified. Confirm with system operation and complete custody handover, close out any project and technical documents if required.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "B",
          title: "Closed",
          icon: "copyright",
          lvl: 12,
          comn: "All work completed and audited.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        }
      ],
      transitionsFlowModelBO: [
        {
          type: "BO", // type of decision
          title: "Created", // type of step
          icon: "add", // icon for decision
          lvl: 1, // stage / level of approval
          // eslint-disable-next-line
          comn: "Review order request and scope, confirm budget availability. Ensure the order is not covered by other business process, i.e. no duplicates.", // comment next (next step)
          comc: "Operation is completed.", // comment current (comc)
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "BO",
          title: "Quote",
          icon: "request_quote",
          lvl: 2,
          // eslint-disable-next-line
          comn: "Request for quote from the approved vendors. Multiple quotes may be required, considering financial and carbon costs.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "BO",
          title: "Review",
          icon: "edit_note",
          lvl: 3,
          // eslint-disable-next-line
          comn: "Review quotes and select preferred vendor for parts, services and transport. Consider price, availability and technical capability. Review vendor Terms and Conditions, seek clarification if required.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "BO",
          title: "Recommend",
          icon: "today",
          lvl: 4,
          // eslint-disable-next-line
          comn: "Review selected vendor or vendors. Finalise any technical queries, confirm the delivery and due dates for approved plan and ensure all outstanding actions are closed. Assign Order priroity.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "BO",
          title: "Authorsie",
          icon: "shield",
          lvl: 5,
          // eslint-disable-next-line
          comn: "Review recommended Order. Approve or reject the order.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "BO",
          title: "Order",
          icon: "next_week",
          lvl: 6,
          // eslint-disable-next-line
          comn: "Place Order as per the Decision. Commit funds, goods or services to Order Requestor. The transfer of value may be in full or transferred in portions.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "BO",
          title: "Technical",
          icon: "settings",
          lvl: 7,
          // eslint-disable-next-line
          comn: "Finalise all design and service technical issues at vendor premises prior to mobilisation to site. Quality assurance process should be followed.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "BO",
          title: "Transport",
          icon: "local_shipping",
          lvl: 8,
          // eslint-disable-next-line
          comn: "Goods and services have left the supplier facilities. Monitor transport dates, prepare site for delivery/arrival, confirm the estimated arrival time still aligns with business processes and consider to increase transport priority if required.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "BO",
          title: "Quality",
          icon: "verified",
          lvl: 9,
          // eslint-disable-next-line
          comn: "Confirm delivered goods and services are of high quality prior to work activity or conduct a safety auidt with the vendor prior to work. Stock reorder process follows local warehouse inbound quality procedures.",
          // eslint-disable-next-line
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "BO",
          title: "Completed",
          icon: "check_box",
          lvl: 10,
          // eslint-disable-next-line
          comn: "Deliver materials to warehouse storage or to site location. Ordered goods and services can now be used for other business processes such as work or stock levels.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "BO",
          title: "Invoice",
          icon: "paid",
          lvl: 11,
          // eslint-disable-next-line
          comn: "Process invoices and remaining payments. Review completed work process if required to check for quality assurance.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "BO",
          title: "Closed",
          icon: "copyright",
          lvl: 12,
          // eslint-disable-next-line
          comn: "Order is closed and all payments are processed.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        }
      ],
      transitionsFlowModelCP: [
        {
          type: "CP", // type of decision
          title: "Created", // type of step
          icon: "add", // icon for decision
          lvl: 1, // stage / level of approval
          // eslint-disable-next-line
          comn: "Confirm plan requirements for current business, operations or maintenance. Validate no duplicate plan is currently available.", // comment next (next step)
          comc: "Operation is completed.", // comment current (comc)
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "CP",
          title: "Review",
          icon: "sync_alt",
          lvl: 2,
          // eslint-disable-next-line
          comn: "Review presented plan in the context of resource requirements and impact to the business. Validate the proposed schedule is aligned with business priorities.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "CP",
          title: "Develop",
          icon: "settings_suggest",
          lvl: 3,
          // eslint-disable-next-line
          comn: "Prepare detailed plan design, engage business and technical subject matter experts, ensure all business units are engaged including operations, maintenance and engineering. Ensure that work list is complete and scope of overall plan is clearly defined.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "CP",
          title: "Recommend",
          icon: "manage_accounts",
          lvl: 4,
          // eslint-disable-next-line
          comn: "Review the recommended plan to the business. Ensure plan scope and business limits are respected and appropriate budget was assigned to the activity.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "CP",
          title: "Decide",
          icon: "shield",
          lvl: 5,
          // eslint-disable-next-line
          comn: "Decide to approve or reject the Plan. Note the Plan approval will authorise site and project preparations which will commit resources to the activity.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "CP",
          title: "Approved",
          icon: "verified",
          lvl: 6,
          // eslint-disable-next-line
          comn: "Plan is ready to use, the preparation and execution have commenced. Any material and significant change to the Plan should seek reapproval as per company processes.",
          // eslint-disable-next-line
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "CP",
          title: "Close Out",
          icon: "check_box",
          lvl: 7,
          // eslint-disable-next-line
          comn: "Plan was executed. Reflect lessons learnt during planning, preparation and execution stages.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "CP",
          title: "Closed",
          icon: "copyright",
          lvl: 8,
          // eslint-disable-next-line
          comn: "Plan is closed, lessons learnt if applicable were communicated. The process can be financially or technically audited.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        }
      ],
      transitionsFlowModelCB: [
        {
          type: "CB", // type of decision
          title: "Created", // type of step
          icon: "add", // icon for decision
          lvl: 1, // stage / level of approval
          // eslint-disable-next-line
          comn: "Confirm budget justifications and requirements. Validate no duplicate budgets for the proposed financial period.", // comment next (next step)
          comc: "Operation is completed.", // comment current (comc)
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "CB",
          title: "Review",
          icon: "sync_alt",
          lvl: 2,
          // eslint-disable-next-line
          comn: "Prepare scope of work for the budget. Provide additional external support information if required.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "CB",
          title: "Develop",
          icon: "settings_suggest",
          lvl: 3,
          // eslint-disable-next-line
          comn: "Develop budget detailed plan. Prepare Class 1 estimates for cost and carbon allocation. Consult activities with technical and business subject matter experts. Seek input from external vendors if required. Prepare high level of detail budget plan.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "CB",
          title: "Recommend",
          icon: "manage_accounts",
          lvl: 4,
          // eslint-disable-next-line
          comn: "Review the recommended budget position to the business. Consider budget variation if required, review if the calculated estimates are reasonable and aligned with business priorities and budget scope.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "CB",
          title: "Decide",
          icon: "shield",
          lvl: 5,
          // eslint-disable-next-line
          comn: "Review the budget and approve or reject or seek clarification. Budget approval authorises release of funds and generation of financial orders for goods and services.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "CB",
          title: "Approved",
          icon: "verified",
          lvl: 6,
          // eslint-disable-next-line
          comn: "Budget is ready to use. Approved budget amount can be spent on goods and services for assigned period.",
          // eslint-disable-next-line
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "CB",
          title: "Reflect",
          icon: "check_box",
          lvl: 7,
          // eslint-disable-next-line
          comn: "Review budget close out metrics, cost and carbon management post implementation and expenditure. Report any financial non compliance to the company accountant.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "CB",
          title: "Closed",
          icon: "copyright",
          lvl: 8,
          // eslint-disable-next-line
          comn: "Budget is closed and no longer valid. Financial audit is possible.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        }
      ],
      transitionsFlowModelCS: [
        {
          type: "CS", // type of decision
          title: "Created", // type of step
          icon: "add", // icon for decision
          lvl: 1, // stage / level of approval
          // eslint-disable-next-line
          comn: "Confirm no duplicate maintenance strategies. Ensure the strategy aligns with technical and corporate policy. Validate a level of maintenance strategy reach - company wide or facility specific.", // comment next (next step)
          comc: "Operation is completed.", // comment current (comc)
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "CS",
          title: "Develop",
          icon: "sync_alt",
          lvl: 2,
          // eslint-disable-next-line
          comn: "Import equipment type, analyse failure modes and develop detailed maintenance activity program. The development of strategy detail may be part of independent study to provide input for the right maintenance applicable to selected equipment type.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "CS",
          title: "Review",
          icon: "settings_suggest",
          lvl: 3,
          // eslint-disable-next-line
          comn: "Review proposed maintenance strategy change or new proposal considering failure modes and criticality analysis. Identify any local regulatory requirements for selected equipment types.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "CS",
          title: "Recommend",
          icon: "manage_accounts",
          lvl: 4,
          // eslint-disable-next-line
          comn: "Review approved maintenance strategy and associated maintenance activities in the context of business impact, practicality and planning conflicts. Recommend the Strategy to the sponsor.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "CS",
          title: "Decide",
          icon: "shield",
          lvl: 5,
          // eslint-disable-next-line
          comn: "Decide to approve new maintenance strategy or modification considering technical and business constraints and the benefit to the business.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "CS",
          title: "Approved",
          icon: "verified",
          lvl: 6,
          // eslint-disable-next-line
          comn: "Periodically audit the maintenance strategy and monitor for compliance to internal and external standards updates.",
          // eslint-disable-next-line
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "CS",
          title: "Suspended",
          icon: "block",
          lvl: 8,
          // eslint-disable-next-line
          comn: "Maintenance strategy is suspended or superseded. Maintenance Plan generation is not possible.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        }
      ],
      transitionsFlowModelD: [
        {
          type: "D", // type of decision
          title: "Created", // type of step
          icon: "add", // icon for decision
          lvl: 1, // stage / level of approval
          // eslint-disable-next-line
          comn: "Review the event or the incident and confirm site was made safe and the evidence was preserved for the investigation.", // comment next (next step)
          comc: "Operation is completed.", // comment current (comc)
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "D",
          title: "Scope",
          icon: "sync_alt",
          lvl: 2,
          // eslint-disable-next-line
          comn: "Define investigation scope and limits together with Site Manager or Investigation Sponsor. Assign investigation team leader and consider resource requirements to complete the investigation by due  date.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "D",
          title: "Investigation",
          icon: "settings_suggest",
          lvl: 3,
          // eslint-disable-next-line
          comn: "Complete investigation within defined scope. Report to Site Manager or Investigation Sponsor if the investigation is not able to be completed by due date or within defined scope due to investigation site access restriction or lack of evidence.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "D",
          title: "Recommend",
          icon: "manage_accounts",
          lvl: 4,
          // eslint-disable-next-line
          comn: "Review investigation outcomes, factors and root cause. Analyse impacted risk barriers and risk controls during the event. Confirm investigation outcome and recommendations or seek clarification from the investigation team.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "D",
          title: "Decide",
          icon: "shield",
          lvl: 5,
          // eslint-disable-next-line
          comn: "Decide if incident recommendations are accepted. Review if the investigation process addresses  defined investigation scope. Check if the event should be communicated to other facilities as lesson learnt.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "D",
          title: "Action",
          icon: "adjust",
          lvl: 6,
          // eslint-disable-next-line
          comn: "Complete investigation actions if applicable and / or communicate to the site team investigation decision.",
          // eslint-disable-next-line
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "D",
          title: "Complete",
          icon: "check_box",
          lvl: 7,
          // eslint-disable-next-line
          comn: "Review actions are implemented and completed to defined standard of the safety or production investigations or confirm site team is aware of investigation outcome.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "D",
          title: "Closed",
          icon: "copyright",
          lvl: 8,
          // eslint-disable-next-line
          comn: "Investigation is completed, communicated and all actions are closed if applicable. Investigation is open for safety or process audit.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        }
      ],
      transitionsFlowModelE: [
        {
          type: "E", // type of decision
          title: "Created", // type of step
          icon: "add", // icon for decision
          lvl: 1, // stage / level of approval
          // eslint-disable-next-line
          comn: "Define action type, theme, priority justification and scope with reasonable due date, update if required. If appropriate assign company or facility staff or contractor to complete the action.", // comment next (next step)
          comc: "Operation is completed.", // comment current (comc)
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "E",
          title: "Progress",
          icon: "account_circle",
          lvl: 2,
          // eslint-disable-next-line
          comn: "Review assigned action scope. Identify resource impact, detailed plan and confirm action can be completed with quality result by the proposed due date. Plan to complete the tasks to achieve actions deliverables.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "E",
          title: "Ready",
          icon: "playlist_add_check",
          lvl: 3,
          // eslint-disable-next-line
          comn: "Action is resourced, the scope plan is approved and ready to execute. If required obtain permission to complete action during approved operational window or access to site.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "E",
          title: "Completed",
          icon: "check_box",
          lvl: 4,
          // eslint-disable-next-line
          comn: "Action is completed. Validate if action was completed as per original scope of work. If action completion quality is not adequate describe potential lessons learnt.",
          comc: "Validate if completed as per request.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "E",
          title: "Closed",
          icon: "verified_user",
          lvl: 5,
          // eslint-disable-next-line
          comn: "Action is closed, approved with agreed quality outcome. The action is ready for audit or the archive process can be commenced.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        }
      ],
      transitionsFlowModelO: [
        {
          type: "O", // type of decision
          title: "Created", // type of step
          icon: "add", // icon for decision
          // eslint-disable-next-line
          comn: "Review new request", // comment next (next step)
          comc: "Operation is completed.", // comment current (comc)
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "O",
          title: "Agreed",
          icon: "account_circle",
          // eslint-disable-next-line
          comn: "User approval process is completed",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "O",
          title: "Ready",
          icon: "playlist_add_check",
          // eslint-disable-next-line
          comn: "User approval process is completed",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "O",
          title: "Resolved",
          icon: "adjust",
          // eslint-disable-next-line
          comn: "User approval process is completed",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        }
      ],
      transitionsFlowModelW: [
        {
          type: "W", // type of decision
          title: "Created", // type of step
          icon: "add", // icon for decision
          // eslint-disable-next-line
          comn: "Review new request", // comment next (next step)
          comc: "Operation is completed.", // comment current (comc)
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "W",
          title: "Validated",
          icon: "troubleshoot",
          // eslint-disable-next-line
          comn: "User approval process is completed",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "W",
          title: "Solution",
          icon: "troubleshoot",
          // eslint-disable-next-line
          comn: "User approval process is completed",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "W",
          title: "Closed",
          icon: "troubleshoot",
          // eslint-disable-next-line
          comn: "User approval process is completed",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        }
      ],
      transitionsFlowModelY: [
        {
          type: "Y", // type of decision
          title: "Created", // type of step
          icon: "add", // icon for decision
          // eslint-disable-next-line
          comn: "Review access request requirements, provide additional information or justification for access authorisation.", // comment next (next step)
          comc: "Operation is completed.", // comment current (comc)
          desn: "", // desciption of next step
          desc: "" // description of current step
        },
        {
          type: "Y",
          title: "User Decided",
          icon: "troubleshoot",
          // eslint-disable-next-line
          comn: "User approval process is completed. Access decision was delivered and notification sent.",
          comc: "Operation is completed.",
          desn: "", // desciption of next step
          desc: "" // description of current step
        }
      ]
    };
  }
};
